:host {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;

    label {
        color: var(--solid-ui-color-gray-600);
        font-size: var(--solid-ui-font-size-sm);
        font-weight: 400;
    }

    .input-wrapper {
        position: relative;
        width: 100%;

        select {
            appearance: none;
            border: 1px solid var(--solid-ui-color-gray-400);
            border-radius: 5px;
            padding: 10px;
            padding-right: 40px;
            width: 100%;
            background: white;
            color: var(--solid-ui-color-gray-700);
            font-size: inherit;
            cursor: pointer;
        }

        icon-lucide-chevron-down {
            position: absolute;
            right: 15px;
            top: 50%;
            transform: translateY(-50%);
            color: var(--solid-ui-color-gray-500);
            width: var(--solid-ui-font-size-lg);
            height: var(--solid-ui-font-size-lg);
            pointer-events: none;
        }
    }
}
